import fetch, { METHOD } from '../fetch'

export const confirmUser = async (uuid) => {
  const { status } = await fetch(METHOD.POST, '/auth/signup-confirm', { uuid })
  return status
}
